// extracted by mini-css-extract-plugin
export var cardHeader = "_ep-0";
export var reorderHandle = "_ep-3";
export var titleArea = "_ep-1";
export var titleAreaWithHandle = "_ep-2";